import * as Redux from 'redux';
import { IActionCreator } from '../../../interfaces/IActionCreator';
import { Keys } from './types';
import { invokeApi } from '../../../networking/invoker';
import { contact, contactPaginationResponse, createContact } from '../../../../model/contact';
import { myroom } from '../../../../model/myroom';

import moment from 'moment';
import { notifActionCreator } from '../../notification/actions/creators';

export interface IActions {
    loadContacts: (fullnameOrEmail: string, tag: string, take?: number) => Promise<Array<contact>>;
    loadContactsPaginated: (fullnameOrEmail: string, tag: string, page: number, take?: number) => Promise<contactPaginationResponse>;
    loadRecentContacts: (take?: number) => Promise<Array<contact>>;
    loadContactReservations: (sub: string) => void;
    clearContactSelection: () => void;
    // addUserInCache: (fullnameOrEmail: string) => void;
    loadContact: (Id: string) => void;
    userConnected: (sub: string, connId: string) => void;
    addNewUser: (contact: createContact) => Promise<contact>;
    userDisconnected: (sub: string) => void;
    print: (tagIds: string[]) => any;
    download: (tagIds: string[]) => any;
    addRoom: (sub: string, room: myroom) => any;
    removeRoom: (sub: string, roomId: string) => any;
    updateRoom: (sub: string, room: myroom) => any;
    saveCardNumber: (sub: string, cardNumber: string) => any;
    saveBlockAccessDate: (sub: string, blockAccessOn?: Date) => any;
    saveGreenPass: (sub: string, newGreenPass: boolean, greenPassExpireOn?: Date) => any;
}



function parseQueryStringParameters(fullnameOrEmail: string, tag: string, page?: number, take?: number) {
    let parsed = ``
    if (fullnameOrEmail || tag) {
        parsed = parsed.concat(`?`);
        if (fullnameOrEmail) {
            parsed = parsed.concat(`fullnameOrEmail=${fullnameOrEmail}`);
        }
        if (tag) {
            if (parsed.length > 1) {
                parsed = parsed.concat(`&`);
            }
            parsed = parsed.concat(`tag=${tag}`);
        }
    }
    if (parsed.length === 0) {
        parsed = parsed.concat(`?`);
    }
    if (page !== undefined) {
        if (parsed.length > 1) {
            parsed = parsed.concat(`&`);
        }
        parsed = parsed.concat(`page=${page}`);
    }
    if (take) {
        if (parsed.length > 1) {
            parsed = parsed.concat(`&`);
        }
        parsed = parsed.concat(`take=${take}`);
    }
    return parsed;
}

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        saveGreenPass: (sub: string, isNewGreenPass: boolean, greenPassExpireOn?: Date) => {
            let date = moment(greenPassExpireOn).format('YYYYMMDD');
            var api = `/api/Contact/${sub}/GreenPass/${greenPassExpireOn === undefined ? null : date}`;
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.SAVEGREENPASS,
                    payload: invokeApi({
                        path: api,
                        method: isNewGreenPass ? 'POST' : 'PUT',
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            })
        },
        saveBlockAccessDate: (sub: string, blockAccessOn?: Date) => {
            var api = `/api/Contact/${sub}/LockAccess/unlock`;
            if (blockAccessOn !== undefined) {
                let date = moment(blockAccessOn).format('YYYYMMDD');
                api = `/api/Contact/${sub}/LockAccess/lock/${date}`;
            }
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.SAVEBLOCKACCESSDATE,
                    payload: invokeApi({
                        path: api,
                        method: 'PUT',
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            })
        },
        saveCardNumber: (sub: string, cardNumber: string) => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.SAVECARDNUMBER,
                    payload: invokeApi({
                        path: `/api/Contact/${sub}/card/${cardNumber}`,
                        method: 'POST',
                    }).then(resp => {
                        res(resp);
                        return resp;
                    }).catch((a: contact) => {
                        let msg = "Il numero di tessera è assegnato a : " + a.name + " " + a.surname + " " + a.email;
                        notifActionCreator(dispatch).setSaveNotification({ result: false, message: msg });
                    })
                })
            })
        },
        loadContacts: (fullnameOrEmail: string, tag: string, take?: number) => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOADCONTACTS,
                    payload: invokeApi({
                        path: '/api/Contacts' + parseQueryStringParameters(fullnameOrEmail, tag, undefined, take),
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
        loadRecentContacts: (take?: number) => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOADRECENTCONTACTS,
                    payload: invokeApi({
                        path: take ? '/api/Contacts/recent?take=' + take
                            : '/api/Contacts/recent',
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
        loadContactsPaginated: (fullnameOrEmail: string, tag: string, page: number, take?: number) => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOADCONTACTSPAGINATED,
                    meta: page,
                    payload: invokeApi({
                        path: '/api/Contacts/paginated' + parseQueryStringParameters(fullnameOrEmail, tag, page, take),
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
        loadContactReservations: (sub: string) => {
            dispatch({
                type: Keys.LOADCONTACTRESERVATIONS,
                payload: invokeApi({
                    path: '/api/Reservations/user/' + sub,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        loadContact: (id: string) => {
            console.info("loadContact:", id)
            dispatch({
                type: Keys.LOADCONTACT,
                payload: invokeApi({
                    path: '/api/Contacts/' + id,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        userConnected: (sub, connId) => {
            dispatch({
                type: Keys.USERCONNECTED,
                payload: { sub, connId }
            })
        },
        clearContactSelection: () => {
            dispatch({
                type: Keys.CLEARSELECTION,
            })
        },
        userDisconnected: (sub) => {
            dispatch({
                type: Keys.USERDISCONNECTED,
                payload: sub
            })
        },
        print: (tagIds: string[]) => {
            dispatch({
                type: Keys.PRINT,
                payload: invokeApi({
                    path: '/api/Contacts/print',
                    method: 'POST',
                    body: tagIds,
                    responseType: 'json'
                }),
            })
        },
        download: (tagIds: string[]) => {
            dispatch({
                type: Keys.DOWNLOAD,
                payload: invokeApi({
                    path: '/api/Contacts/download',
                    method: 'POST',
                    body: tagIds,
                    responseType: 'json'
                }),
            })
        },
        addRoom: (sub: string, room: myroom) => {
            const path = '/api/Contact/' + sub + '/Rooms';
            dispatch({
                type: Keys.ADDROOM,
                meta: room,
                payload: invokeApi({
                    path: path,
                    method: 'POST',
                    body: room,
                    responseType: 'json'
                }),
            })
        },
        removeRoom: (sub: string, roomId: string) => {
            const path = '/api/Contact/' + sub + '/Rooms/' + roomId;
            dispatch({
                type: Keys.DELETEROOM,
                meta: roomId,
                payload: invokeApi({
                    path: path,
                    method: 'DELETE',
                    body: null,
                    responseType: 'json'
                }),
            })
        },
        updateRoom: (sub: string, room: myroom) => {
            const path = '/api/Contact/' + sub + '/Rooms';
            dispatch({
                type: Keys.UPDATEROOM,
                meta: room,
                payload: invokeApi({
                    path: path,
                    method: 'PUT',
                    body: room,
                    responseType: 'json'
                }),
            })
        },
        addNewUser: (contact: createContact) => {
            return new Promise((res, rej) =>
                dispatch({
                    type: Keys.ADDNEWUSER,
                    payload: invokeApi({
                        path: '/api/Contacts/webapp',
                        method: 'POST',
                        body: contact,
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    }),
                })
            )
        },
    }
}

